export default [
  {
    path: '/quotation',
    name: 'quotation',
    component: () => import('@/views/quotation/index'),
    meta: { title: '行情' }
  },
  {
    path: '/contract',
    name: 'contract',
    component: () => import('@/views/quotation/contract'),
    meta: { title: '合约' }
  },//guide calculator
  {
    path: '/currency',
    name: 'currency',
    component: () => import('@/views/quotation/currency'),
    meta: { title: '币币' }
  },
  {
    path: '/currency_history',
    name: 'currency_history',
    component: () => import('@/views/quotation/currency_history'),
    meta: { title: '币币交易记录' }
  },
  {
    path: '/guide',
    name: 'guide',
    component: () => import('@/views/quotation/guide'),
    meta: { title: '合作指南' }
  },
  {
    path: '/calculator',
    name: 'calculator',
    component: () => import('@/views/quotation/calculator'),
    meta: { title: '合作指南' }
  },
  // history
  {
    path: '/history',
    name: 'history',
    component: () => import('@/views/quotation/history'),
    meta: { title: '合作交易历史记录' }
  },
  {
    path: '/diagram',
    name: 'diagram',
    component: () => import('@/views/quotation/diagram'),
    meta: { title: '合约K线图' }
  },
  {
    path: '/forex',
    name: 'forex',
    component: () => import('@/views/quotation/forex'),
    meta: { title: '外汇详情' }
  },
  {
    path: '/forexList',
    name: 'forexList',
    component: () => import('@/views/quotation/forexList'),
    meta: { title: '外汇列表' }
  },
  {
    path: '/editForex',
    name: 'editForex',
    component: () => import('@/views/quotation/editForex'),
    meta: { title: '修改价位' }
  },
  {
    path: '/forexHistory',
    name: 'forexHistory',
    component: () => import('@/views/quotation/forexHistory'),
    meta: { title: '外汇交易历史记录' }
  },
  {
    path: '/myForex',
    name: 'myForex',
    component: () => import('@/views/quotation/myForex'),
    meta: { title: '我的交易' }
  },
  {
    path: '/forexDiagram',
    name: 'forexDiagram',
    component: () => import('@/views/quotation/forexDiagram'),
    meta: { title: '外汇k线图' }
  },
]



// WEBPACK FOOTER //
// ./src/router/config/Quotation.js